export default __webpack_public_path__ + "static/media/Account-created.22bee495.svg";